import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AuthService } from 'src/app/services/api/auth/auth.service';

@Component({
    selector: 'app-confirm-register',
    templateUrl: './comfirm-register.component.html',
    styleUrls: ['./comfirm-register.component.scss']
})

export class ComfirmRegisterComponent implements OnInit {
    showTimer: boolean = false;
    showPageValidateEmail: boolean = false;
    timer: number = 120; 
    intervalId: any;
    @Input() validationEmail = false;
    @Input() userEmail: string = '';
    @Output() close = new EventEmitter<void>();
    isLoading: boolean = false;

    constructor(private authService: AuthService) {}

    ngOnInit() {
    }

    closeConfirmRegister() {
        this.close.emit();
    }

    startTimer() {
        this.showTimer = true;
        this.timer = 120;
        this.intervalId = setInterval(() => {
            if (this.timer > 0) {
                this.timer--;
            } else {
                this.showTimer = false;
                clearInterval(this.intervalId);
            }
        }, 1000);
    }

    get formattedTime(): string {
        const min = Math.floor(this.timer / 60).toString().padStart(2, '0');
        const sec = (this.timer % 60).toString().padStart(2, '0');
        return `${min}:${sec}`;
    }




    resendEmailEvent() {
        this.showPageValidateEmail = true;
        this.isLoading = true;
        this.authService.resendEmail(this.userEmail).subscribe({
            next: () => {
                this.startTimer();
                this.isLoading = false;
            },
            error: () => {
                this.isLoading = false;
                throw new Error('Error al reenviar el correo');
            }
        });
    }
}